export default "__VITE_ASSET__Bmh5pRAX__"